import { ChevronDoubleLeftIcon, ChevronDoubleRightIcon } from '@heroicons/react/24/outline';

type SidebarCollapseToggleProps = {
  collapsed: boolean;
  onToggle: () => void;
};

export function SidebarCollapseToggle({ collapsed, onToggle }: SidebarCollapseToggleProps) {
  const label = collapsed ? 'Expandir menu' : 'Recolher menu';

  return (
    <div className={`border-t border-white/15 p-2 ${collapsed ? '' : 'px-3'}`}>
      <button
        type="button"
        onClick={onToggle}
        title={label}
        aria-label={label}
        aria-expanded={!collapsed}
        className={`flex w-full items-center rounded-xl py-2 text-sm font-medium text-primary-100 transition-colors hover:bg-white/10 hover:text-white ${
          collapsed ? 'justify-center px-2' : 'gap-3 px-3'
        }`}
      >
        {collapsed ? (
          <ChevronDoubleRightIcon className="h-5 w-5 shrink-0" aria-hidden="true" />
        ) : (
          <ChevronDoubleLeftIcon className="h-5 w-5 shrink-0" aria-hidden="true" />
        )}
        {!collapsed ? <span>Recolher</span> : null}
      </button>
    </div>
  );
}
